import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { ErrorService } from './error.service';

import { Carrier, CarrierPage, CarrierList, CarrierFleet, CarrierUser } from './../models/carrier';

@Injectable()
export class CarrierService {

  private url = CommonService.getEwdApiURL() + 'carrier';

  constructor(
    private http: Http,
    private errorService: ErrorService
  ) { }

  private getUrlwith(id) {
      return this.url + '/' + id;
  }

  getCarriers(): Observable<Carrier[]> {
        return this.http.get(this.url)
            .map((response: Response) => response.json());
  }

  getCarrierList(): Observable<CarrierList[]> {
        return this.http.get(this.url + '/SelectList')
            .map((response: Response) => response.json());
  }

  getCarrier(id): Observable<Carrier> {
      return this.http.get(this.getUrlwith(id))
          .map((response: Response) => {
              if (response.status === 204) {
                this.errorService.handleError(response);
              };
              return response.json();
          });
  }

  getCarrierInfo(id): Observable<Carrier> {
    return this.http.get(this.getUrlwith(id) + "/info")
        .map((response: Response) => {
            if (response.status === 204) {
              this.errorService.handleError(response);
            };
            return response.json();
        });
}

getCarrierByUser(userName): Observable<Carrier> {
    return this.http.get(this.url + '/user/' + userName)
        .map((response: Response) => {
            if (response.status === 204) {
              this.errorService.handleError(response);
            };
            return response.json();
        });
}

  getCarrierUser(userName: string): Observable<CarrierUser> {
    return this.http.get(this.url + '/GetCarrierUserByUserName/' + userName)
    .map(
        (response: Response) => response.json()
        );
  }

  addCarrier(carrier: Carrier): Observable<number> {
      return this.http.post(this.url, carrier)
          .map(
              (response: Response) => response.json()
              );
  }

  updateCarrier(id, carrier: Carrier): Observable<boolean> {
      return this.http.put(this.getUrlwith(id), carrier)
          .map((response: Response) => {
              return true;
          });
  }

}
